
seedWebServices.service('TranslationService', ['$resource', function ($resource) {

    var self = this;

    this.getTranslation = function ($scope, language) {
        console.log('getTranslation ' + language);
        if (angular.isUndefined(language)) {
            language = 'pt-br';
        }
        var languageFilePath = 'Translations/translation_' + language + '.json' + seedWebApp.buildVersion;
        var useCache = true;
        $resource(languageFilePath, {}, { get: { method: 'GET', params: {}, isArray: false, cache: useCache } }).get(function get(data) {
            $scope.translation = data;
            self.translation = data;
            self.language = language;
        }, function errorFunc(errorDescription) {
            $scope.errorDescription = errorDescription;
        });
    };

    this.getActiveTranslation = function () {
        if (!self.translation) {
            this.getTranslation({});
        }
        return self.translation;
    };

    this.translation = null;
}]);